import useAssets from "hooks/useAssets";
import { generateRandomInteger } from "utils/numberUtils";
import { fancyBearsAmount } from "config";
import { Navigate } from "react-router-dom";

type BearRedirectProps = {
  basePath: string;
};

const getRandomBear = () => generateRandomInteger(1, fancyBearsAmount);

const BearRedirect = ({ basePath }: BearRedirectProps) => {
  const { fancyBearsInWallet } = useAssets();

  const defaultBear =
    (localStorage.getItem("lastTokenId") &&
      parseInt(localStorage.getItem("lastTokenId")!, 10)) ||
    fancyBearsInWallet?.[1] ||
    getRandomBear();

  return <Navigate to={`${basePath}/${defaultBear}`} replace />;
};

BearRedirect.storeLastTokenId = (tokenId?: number) => {
  if (tokenId) {
    localStorage.setItem("lastTokenId", tokenId.toString());
  }
};

export default BearRedirect;
